var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGmail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 34.509,
    viewBox: "0 0 46 34.509",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4285f4;\n      }\n\n      .cls-2 {\n        fill: #34a853;\n      }\n\n      .cls-3 {\n        fill: #fbbc04;\n      }\n\n      .cls-4 {\n        fill: #ea4335;\n        fill-rule: evenodd;\n      }\n\n      .cls-5 {\n        fill: #c5221f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "official-gmail-icon-2020-",
    transform: "translate(0 -64.724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3005",
    "data-name": "Group 3005",
    transform: "translate(0 64.724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4354",
    "data-name": "Path 4354",
    className: "cls-1",
    d: "M3.136,189.341h7.318V171.568L0,163.727V186.2a3.136,3.136,0,0,0,3.136,3.136Z",
    transform: "translate(0 -154.832)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4355",
    "data-name": "Path 4355",
    className: "cls-2",
    d: "M395.636,189.341h7.318a3.136,3.136,0,0,0,3.136-3.136V163.727l-10.455,7.841Z",
    transform: "translate(-360.091 -154.832)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4356",
    "data-name": "Path 4356",
    className: "cls-3",
    d: "M395.636,67.869V81.46l10.455-7.841V69.437a4.7,4.7,0,0,0-7.527-3.764Z",
    transform: "translate(-360.091 -64.724)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4357",
    "data-name": "Path 4357",
    className: "cls-4",
    d: "M116.364,113.318V99.727l12.545,9.409,12.545-9.409v13.591l-12.545,9.409Z",
    transform: "translate(-105.909 -31.858)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4358",
    "data-name": "Path 4358",
    className: "cls-5",
    d: "M0,69.437v4.182L10.455,81.46V67.869l-2.927-2.2A4.7,4.7,0,0,0,0,69.437Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gmail.29157bb5a47fd97b2de2ebe9ce13b714.svg";